/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { convertToSentenceCase } from 'ml-portals-util-js';
import appConfig from 'app-config';
import _ from 'lodash';
import '@xengage/gw-platform-translations';
import styles from './MLHOConditionsCoverageComponent.module.scss'
import metadata from './MLHOConditionsCoverageComponent.metadata.json5';
import messages from './MLHOConditionsCoverageComponent.messages';

const SPECIAL_LIMITATIONS_ID = 'ztsg0okd8lvaha25n1nr1cmt9n9';
const isQnB = appConfig.portalCode === 'QB';

function MLHOConditionsCoverageComponent(props) {
    const {
        model,
        index
    } = props;
    const translator = useTranslator();

    const isSpecialLimitations = model.publicID === SPECIAL_LIMITATIONS_ID;

    const [isSpecialLimitationsVisible, setIsSpecialLimitationsVisible] = useState(false);

    const toggleSpecialLimitationsSection = () => {
        setIsSpecialLimitationsVisible(!isSpecialLimitationsVisible);
    };

    const generateTermOverrides = useCallback((evenOrOdd) => {
        const selectedTerms = model.terms.filter((term, idx) => evenOrOdd === 'Even' ? (idx % 2 === 0) : (idx % 2 === 1));
        const termOverrides = selectedTerms.map((term, termIndex) => {
            return {
                [`parentTermIterableDiv${evenOrOdd}${index}${termIndex}`]: {
                    visible: term.isVisible_ML
                },
                [`specialLimitationsName${evenOrOdd}${index}${termIndex}`]: {
                    content: `${term.name}:`
                },
                [`termDescriptionTooltip${evenOrOdd}${index}${termIndex}`]: {
                    tooltipContent: term.description_ML,
                    noWrapper: true
                },
                [`termSelect${evenOrOdd}${index}${termIndex}`]: {
                    visible: term.options && term.options.length > 1,
                    disabled: term.updating || !term.isEditable_ML
                },
                [`termChosenValSpecialLimit${evenOrOdd}${index}${termIndex}`]: {
                    visible: isSpecialLimitations,
                    content: term.chosenTermValue
                },
                [`termChosenValNonSpecialLimit${evenOrOdd}${index}${termIndex}`]: {
                    visible: !isSpecialLimitations && (term.options && term.options.length === 1),
                    content: _.get(term, 'options[0].name', '')
                },
                [`termValueInputNonSpecialLimit${evenOrOdd}${index}${termIndex}`]: {
                    visible: (!isSpecialLimitations && (!term.options || term.options.length === 1)) && term.newValue,
                    disabled: term.updating || !term.isEditable_ML
                }
            };
        });

        return Object.assign({}, ...termOverrides);
    }, [index, isSpecialLimitations, model.terms]);

    const specialLimitationMessage = isSpecialLimitationsVisible ? messages.collapse : messages.viewAll;

    const overrides = {
        [`condHeader${index}`]: {
            content: model.name
        },
        [`specialLimitationsButtonContainer${index}`]: {
            visible: isSpecialLimitations
        },
        [`viewSpecialLimitationsBtn${index}`]: {
            content: isQnB ? convertToSentenceCase(translator(specialLimitationMessage)) : translator(specialLimitationMessage),
            className: isQnB ?  "secondaryButton widthSmall" : "pull-right"
        },
        [`subHeaderSpan${index}`]: {
            content: isSpecialLimitations ? translator(messages.subHeaderDesc) : model.description
        },
        [`termsArrayContainer${index}`]: {
            visible: isSpecialLimitations ? isSpecialLimitationsVisible : true
        },
        [`termIterableEven${index}`]: {
            data: model.terms.filter((term, idx) => idx % 2 === 0)
        },
        [`termIterableOdd${index}`]: {
            data: model.terms.filter((term, idx) => idx % 2 === 1)
        },
        ...generateTermOverrides('Even'),
        ...generateTermOverrides('Odd')
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onToggleSpecialLimitationsSection: toggleSpecialLimitationsSection
        }
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, index);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLHOConditionsCoverageComponent.propTypes = {
    coverage: PropTypes.shape({}),
    index: PropTypes.number
};

export default MLHOConditionsCoverageComponent;
